import React from 'react';
import { withCookies } from 'react-cookie';
import { Spin } from 'antd';
import { SearchBar, List, Toast } from 'antd-mobile';
import { Link } from 'react-router-dom';

import MyListView from "./MyListView";
import "./index.css";

const Item = List.Item;
const Brief = Item.Brief;

class FormDataListPage extends React.Component {

    myListView = [];

    constructor(props) {
        super(props)
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);
        this.state = { definitionId: "" };
        if (this.props.location.query) {
            this.state.definitionId = this.props.location.query.definitionId;
        }
        if (!this.state.definitionId) {
            this.state.definitionId = window.sessionStorage.getItem("definitionId");
            window.sessionStorage.setItem("definitionId", "");
        }

        if (!this.state.definitionId) {
            this.props.history.push("/");
        } else {
            window.sessionStorage.setItem("definitionId", this.state.definitionId);
        }
    }

    bindRef = ref => { this.myListView = ref }

    render() {
        return <div className="wrap"><MyListView onRef={this.bindRef} definitionId={this.state.definitionId} status={[0]} formStatus="-100" listType={2} /></div>;
    }
}

export default withCookies(FormDataListPage);